import React from "react";

function ENIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <g clipPath="url(#clip0_484_202)">
        <path
          fill="#fff"
          d="M17.944 7.99a8.976 8.976 0 00-.123-.784h-2.885l2.26-1.928a8.957 8.957 0 00-.664-1.205l-3.697 3.133h-1.563l4.66-3.948a9.261 9.261 0 00-.445-.497l-4.645 3.938V.189a9.094 9.094 0 00-.7-.117V7.99h7.802zM10.142 17.928c.236-.03.47-.07.7-.117v-6.168l4.425 3.816c.35-.339.671-.707.962-1.098l-3.747-3.238h1.564l2.75 2.376c.1-.174.195-.35.284-.531l-2.144-1.845h2.811c.062-.256.114-.517.153-.781h-7.759v7.586zM8.044.05c-.236.026-.47.06-.7.103L7.345 6.7l-4.74-4.032a9.066 9.066 0 00-.841.98L5.95 7.206H4.385L1.205 4.5a9.083 9.083 0 00-.35.665L3.25 7.206H.179a9.117 9.117 0 00-.122.784h7.987V.05zM7.345 17.848c.23.042.463.077.699.101v-7.607H.1c.04.265.09.525.153.782h2.996l-2.266 1.97c.236.46.51.899.82 1.31l3.792-3.28H7.16l-4.697 4.061c.118.125.24.246.365.364l4.517-3.907V17.848z"
        ></path>
        <path
          fill="#BD0034"
          d="M12.835 7.206l3.697-3.133a9.015 9.015 0 00-.601-.815l-4.66 3.948h1.563zM12.482 11.124l3.747 3.237c.205-.275.394-.563.567-.86l-2.75-2.377h-1.564zM5.95 7.206L1.763 3.648c-.202.273-.39.557-.56.852l3.182 2.706H5.95zM5.595 11.124l-3.792 3.28c.205.273.426.534.66.782l4.697-4.062H5.595z"
        ></path>
        <path
          fill="#1A237B"
          d="M15.486 2.762A8.984 8.984 0 0010.841.189v6.51l4.645-3.937zM7.343.153a8.98 8.98 0 00-4.738 2.516l4.74 4.03L7.344.154zM17.821 7.206a8.954 8.954 0 00-.624-1.928l-2.261 1.928h2.885zM17.08 12.968c.286-.582.512-1.2.668-1.844h-2.812l2.144 1.844zM7.345 11.643L2.828 15.55a8.972 8.972 0 004.517 2.297v-6.204zM10.841 17.811a8.982 8.982 0 004.426-2.352l-4.426-3.816v6.169zM.253 11.124a8.94 8.94 0 00.73 1.97l2.266-1.97H.253zM.856 5.165a8.935 8.935 0 00-.677 2.041h3.07L.857 5.166z"
        ></path>
        <path
          fill="#BD0034"
          d="M8.044 17.95a9.149 9.149 0 002.098-.022v-7.586H17.9a9.064 9.064 0 00.043-2.352h-7.802V.072A9.108 9.108 0 008.045.05v7.94H.057A9.128 9.128 0 00.1 10.341h7.944v7.607z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_484_202">
          <path fill="#fff" d="M0 0H18V18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default React.memo(ENIcon);
